<template>
  <div>
    <div
      class="banner"
      :style="{ backgroundImage: 'url(' + backgroundImage + ')' }"
    >
      <div class="banner-title-one">{{ title }}</div>
      <div class="banner-title-two">{{ description }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerDetail",
  props: {
    backgroundImage: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
};
</script>
<style scoped>
.banner {
  float: left;
  width: 100%;
  height: 400px; /* 你可以根据需要调整高度 */
  background-size: cover;
  background-position: center;
  text-align: center;
  padding-top: 100px;
  box-sizing: border-box;
}

.banner-title-one {
  float: left;
  width: 100%;
  font-size: 40px;
  color: #fff;
  margin-bottom: 20px;
  font-weight: 800;
}
.banner-title-two {
  float: left;
  width: 100%;
  font-size: 24px;
  color: #fff;
  margin-bottom: 30px;
  /* letter-spacing: 15px; */
}
@media (max-width: 1200px) {
  .banner {
    height: 200px;
    padding-top: 50px;
  }
  .banner-title-one {
    font-size: 20px;
  }
  .banner-title-two {
    font-size: 14px;
  }
}
</style>